import moment from 'moment';

/*
   @description default date format
 */

export const defaultDateFormat = (date) => moment(date).format('DD-MM-YYYY');
export const defaultDateTimeFormat = (date) => moment(date).format('DD-MM-YYYY HH:MM');

/*
   @description uui for object
 */
export const uuidv4 = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  );
};

export const hasParentNode = (element, classNames) => {
  let parentNode = element.parentNode;
  if (parentNode) {
    if (typeof parentNode.className === 'string' || parentNode.className instanceof String) {
      if (parentNode.className.includes(classNames)) {
        return true;
      }
    }
    return hasParentNode(parentNode, classNames);
  }
  return false;
};

export const sortObjectKeys = (obj, order) => {
  // order true mean asc, false mean descending
  const sortedKeys = Object.keys(obj)
    .filter((key) => key !== 'subTotal') // Exclude 'subTotal' key from sorting
    .sort((a, b) => {
      return order === true ? a.localeCompare(b) : b.localeCompare(a);
    });

  sortedKeys.push('subTotal'); // Add 'subTotal' key at the end for descending order

  const sortedObject = {};
  sortedKeys.forEach((key) => {
    sortedObject[key] = obj[key];
  });

  return sortedObject;
};
